<template>
    <section class="hero-branding bg-cover" :style="bgImg" id="home">
        <div class="container-fluid container-fluid--cp-150">
            <div class="hero-branding">
                <div class="hero-content">
                    <h2 class="h1 hero-content-title">{{ $t("summ.title") }}</h2>
                    <h6 class="hero-content-subtitle mt-20">{{ $t("summ.subtitle") }}</h6>
                    <div class="slider-button mt-30">
                        <b-link href="https://app.trustami.ai/register" target="_blank" class="btn btn--green sign-up-button">
                            {{ $t("summ.signup") }}
                        </b-link>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        data () {
            return {
                bgImg: {
                    backgroundImage: `url(${require('../../assets/img/trustami/code_version_control.svg')})`
                },
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/variabls.scss';
    @import '../../assets/scss/elements/hero-branding.scss';
</style>
